import {Redirect} from '@shopify/app-bridge/actions';
import {ClientApplication} from '@shopify/app-bridge';
import {appBridge} from 'packages/app-bridge';

interface RedirectParams {
  adminUrl: string;
  shopDomain?: string;
  newContext?: boolean;
}

export function redirectToAdminUrl({
  adminUrl,
  shopDomain = '',
  newContext = false,
}: RedirectParams) {
  const redirect = Redirect.create(appBridge!);

  redirect.dispatch(Redirect.Action.ADMIN_PATH, {
    path: adminUrl.replace(`https://${shopDomain}/admin`, ''),
    newContext,
  });
}

export function reloadApp(appBridge: ClientApplication<any>, url: string) {
  const redirect = Redirect.create(appBridge!);

  redirect.dispatch(Redirect.Action.APP, new URL(url).pathname);
}
